import { PartnerCenterEnrollmentStatus } from "@gamedev-web/one-gaming-crm";

import { PartnerAccessDeniedCode } from "../../../../constants/urls";
import {
  CommonIntroContactDataType,
  CommonIntroStudioDataTypeBase,
} from "../../../../models/forms";
import { HubPermissions } from "../../../../models/hubPermissions";
import { OrdersInfoData } from "../../../edsApi/models/forms";
import { FieldOption } from "../models/forms";
import { AccountHubType } from "../utils/hubAccess";

export type XboxOnboardContactData = CommonIntroContactDataType;

export type XboxOnboardStudioData = CommonIntroStudioDataTypeBase;

export type LegalEntityNameChangeState = {
  canRequest: boolean;
  requiresReview: boolean;
  hasActiveRequest: boolean;
  hasNdaSent: boolean;
  isApprovedAwaitingNda: boolean;
  canResendNda: boolean;
  canCancelInquiry?: boolean;
  currentLegalEntityName?: string;
  requestedLegalEntityName?: string;
  requesterDisplayName?: string;
  ndaRecipientEmail?: string;
  ndaNumber?: string;
  maxSupportingDocumentBytes: number;
  allowedSupportingDocumentExtensions: readonly string[];
};

export enum XboxOnboardApplicationStatus {
  Initial = "Initial",
  FormReady = "FormReady",
  Submitted = "Submitted",
  NdaSent = "NdaSent",
  NdaSigned = "NdaSigned",
  Rejected = "Rejected",
}

export type XboxOnboardResponse = {
  status: XboxOnboardApplicationStatus;
  accountType: "id" | "aaa";
  hubType: AccountHubType;
  /**
   * Opaque CRM identifier for the partner, used as the analytics identity.
   * Falls back to the onboarding hub profile id for users who do not have a
   * CRM account yet, so the pre-NDA part of the funnel is not anonymous.
   * Never a personal identifier — see `studio.studioName` for the display name.
   */
  accountId?: string;
  /** ISO country code resolved from the CRM account, when one is available. */
  countryIsoCode?: string;
  hubPermissions: HubPermissions;
  isHubAdmin: boolean;
  isPartnerCenterAccessDenied?: boolean;
  accessDeniedCode?: PartnerAccessDeniedCode;
  contact: XboxOnboardContactData;
  studio: XboxOnboardStudioData;
  partnerCenterEnrollmentStatus: PartnerCenterEnrollmentStatus;
  isOnboardingHubProfileMode: boolean;
  countriesOrRegions: Array<FieldOption>;
  sellerID?: string;
  hasNdaId?: boolean;
  ndaNumber?: string;
  ndaSignedDate?: string;
  ndaSentDate?: string;
  enrollmentDate?: string;
  isFastTrackAccount?: boolean;
  canResendNda?: boolean;
  isEmbargoedCountry?: boolean;
  isIdXboxApproved?: boolean;
  hasStartedIdXboxApplication?: boolean;
  hasApprovedGameConcept?: boolean;
  hasGameConceptWithTlaReceived?: boolean;
  hasSubmittedGameConcept?: boolean;
  hasGameConceptUnderReview?: boolean;
  isGdkSigned?: boolean;
  hasDevelopmentHardwareAccess?: boolean;
  dunsNumber?: string;
  ordersInfo?: OrdersInfoData;
  legalEntityNameChange?: LegalEntityNameChangeState;
  error?: string;
};

export type XboxOnboardSubmitRequest = {
  contact: XboxOnboardContactData;
  studio: XboxOnboardStudioData;
  sellerID?: string;
  dunsNumber?: string;
};

export type XboxOnboardEnrollmentEvidence = {
  dunsValue?: string;
  fileName?: string;
  chunk?: Blob;
  typeFile?: string;
};
